export default {
    chainingDataByKey: {},
    chainingSpecialties: [],
    chainingTypes: [],
}
